import { render } from "./GRNBoxSummary.vue?vue&type=template&id=6076142d&scoped=true"
import script from "./GRNBoxSummary.vue?vue&type=script&lang=js"
export * from "./GRNBoxSummary.vue?vue&type=script&lang=js"

import "./GRNBoxSummary.vue?vue&type=style&index=0&id=6076142d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6076142d"]])

export default __exports__